"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./collection-link.directive"));



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/collection/collection-link/index.js
// module id = ./node_modules/ng2-materialize/dist/collection/collection-link/index.js
// module chunks = vendor